import { type ActivatedRouteSnapshot, type CanActivateFn, type RouterStateSnapshot } from '@angular/router';
import { type AuthGuardData, createAuthGuard } from 'keycloak-angular';
import { environment } from '../../../../environments/environment';

const isAccessAllowed = async (
  _: ActivatedRouteSnapshot,
  __: RouterStateSnapshot,
  authData: AuthGuardData,
): Promise<boolean> => {
  const { authenticated, keycloak } = authData;

  if (!authenticated) {
    await keycloak.login({ redirectUri: `${window.location.origin}${environment.app_path}` });
  }

  return authenticated;
};

export const authGuard = createAuthGuard<CanActivateFn>(isAccessAllowed);
